/**
 * Roles
 */

export const superAdmin = 'SUPER_ADMIN',
    admin = 'ADMIN',
    user = 'USER',
    root = 'ROOT',
    sales = 'SALES';
